<!--
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2023-08-17 13:48:48
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-08-18 10:09:12
-->
<template>
  <div class="jt-modal">
    <Modal v-bind="$attrs">
      <slot></slot>
    </Modal>
  </div>
</template>
<script lang="ts" setup name="JtModal">
  import { Modal } from 'ant-design-vue'
</script>
<style lang="less" scoped></style>
